import React from "react";
import { Col, Row } from "react-bootstrap";
import TabSelector from "../../../library/tab-selector";
import SummaryListsPage from "../dashboard-help-center-pages/lists-summary-page";
import SummaryClientsPage from "../dashboard-help-center-pages/clients-summary-page";
import SummaryCampaignsPage from "../dashboard-help-center-pages/campaigns-summary-page";
import SummaryConactListsPage from "../dashboard-help-center-pages/contact-lists-summary-page";
import SummaryTemplatesPage from "../dashboard-help-center-pages/templates-summary-page";
import PipelineSummaryPage from "../dashboard-help-center-pages/pipeline-summary-page";
import LibrarySummaryPage from "../dashboard-help-center-pages/library-summary-page";
import { Title } from "../../../library/title";
import "./style.scss";

const Index = () => {
  const selectionTabs = [
    {
      key: "lists",
      title: "Lister",
      content: <SummaryListsPage />,
    },
    {
      key: "clients",
      title: "Kunder",
      content: <SummaryClientsPage />,
    },
    {
      key: "campaigns",
      title: "Utsendelser",
      content: <SummaryCampaignsPage />,
    },
    {
      key: "contactlists",
      title: "Kontaktlister",
      content: <SummaryConactListsPage />,
    },
    {
      key: "templates",
      title: "Maler",
      content: <SummaryTemplatesPage />,
    },
    {
      key: "pipeline",
      title: "Pipeline",
      content: <PipelineSummaryPage />,
    },
    {
      key: "library",
      title: "Bibliotek",
      content: <LibrarySummaryPage />,
    },
  ];

  return (
    <div className="dashboard-help-center-display-container">
      <div className="inner-dashboard-help-center-display-container">
        <Row className="upper-row">
          <Col className="title-col">
            <Title size="regular">Få hjelp til å komme i gang</Title>
            <p className="introduction-text">
              På denne siden kan du finne informasjon om hvordan du tar i bruk
              alle deler av tjenesten. Bruk menyen under til å sortere på
              kategori/funksjonaliteter, og trykk deg inn på en hver enkelt
              artikkel for å lese mer. Dersom du ikke finner det du leter etter
              kan du nå oss på alle kanalene vist til høyre.
            </p>
          </Col>
        </Row>
        <div className="tab-selection-container">
          <TabSelector defaultValue="lists" items={selectionTabs} />
        </div>
      </div>
    </div>
  );
};

export default Index;
